export enum USER_ROLE {
  OWNER = 'Owner',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  WORKER = 'Worker',
  SITE_ADMIN = 'SiteAdmin',
  GUEST = 'Guest',
}
